import { Box, styled } from "@mui/material";
import {
    HeroSection,
    FeaturesSection,
    DashboardSection,
    BannerSection,
    GuaranteeSection,
    FAQSection
} from "../components";

import type { Feature } from "../components/FeaturesSection";

const PageContainer = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
}));

const ContentWrapper = styled(Box)(() => ({
    width: "100%",
    marginTop: "-50px",
    borderRadius: "50px 50px 0 0",
    backgroundColor: "var(--background-white)",
    position: "relative",
    zIndex: 2,
    display: "flex",
    justifyContent: "center",
    "@media (max-width: 600px)": {
        marginTop: "-32px",
        borderRadius: "32px 32px 0 0",
    },
}));

const ContentInner = styled(Box)(() => ({
    width: "100%",
    maxWidth: "1440px",
    padding: "106px 120px 60px 120px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "56px",
    "@media (max-width: 600px)": {
        padding: "32px 16px 32px 16px",
        gap: "32px",
    },
}));

const features: Feature[] = [
    {
        title: "Средства под вашим контролем",
        description:
            "Деньги не передаются третьим лицам без контроля.",
    },
    {
        title: "Комплаенс до операции",
        description:
            "Каждая операция проходит предварительную проверку.",
    },
    {
        title: "Инвестирование по закону",
        description:
            "Вы инвестируете в рамках действующего законодательства.",
    },
];



export const InvestPage = () => {
    return (
        <PageContainer>
            <HeroSection
                backgroundImage="/assets/invest-hero.webp"
                title="Доступ к активам по всему миру"
                subtitle="Единая платформа для международных финансов: от банкинга до консалтинга"
            />
            <ContentWrapper>
                <ContentInner>
                    <GuaranteeSection
                        title="Сфера Инвестиции"
                        description="это сервис для частных лиц и компаний, которые хотят управлять капиталом и приобретать активы за пределами одной страны."
                    />
                    <FeaturesSection features={features} />
                    <DashboardSection

                        title="Покупка цифровыхи финансовых активов"
                        description="Title"
                        imageSrc="/assets/invest-dashboard-1.webp"
                    />

                    <DashboardSection
                        reverse
                        title="Покупка недвижимостив любой точке мира"
                        description="Title"
                        imageSrc="/assets/invest-dashboard-2.webp"
                    />

                    <DashboardSection

                        title="Инвестиционные программы трансграничной выручки"
                        description="Title"
                        imageSrc="/assets/invest-dashboard-3.webp"
                    />
                    <DashboardSection
                        reverse
                        title="Сопровождение сделок и защита интересов клиента"
                        description="Title"
                        imageSrc="/assets/invest-dashboard-4.webp"
                    />
                    <DashboardSection
                        title="Доступ к брокерской инфраструктуре через партнёров"
                        description="Title"
                        imageSrc="/assets/invest-dashboard-5.webp"
                    />
                    <DashboardSection
                        reverse
                        title="Юридически корректная структура владения"
                        description="Title"
                        imageSrc="/assets/invest-dashboard-6.webp"
                    />

                    <BannerSection

                        title="Когда капитал работает там, где это выгодно"
                        imageSrc="/assets/invest-banner.webp"
                        imageAlt="GTC Platform"
                    />
                    <FAQSection />
                </ContentInner>
            </ContentWrapper>
        </PageContainer>
    );
};
